module.exports = __webpack_public_path__ + "static/media/01.5fe260a0.jpg";